<div class="container">
    <div class="row">
        <div class="col">
            <div class="jumbotron w-100">
                <h1 class="text-capitalize">Applicazione</h1>
            </div>
        </div>
    </div>

    <div class="row mb-2">
        <div class="col-12">
            <form>
                <div class="col-md-3 col-sm-6 form-group">
                    <label for="app_images" class="cursor-pointer">Galleria +</label>
                    <input type="file" multiple id="app_images" hidden name="app_images" placeholder="Galleria" accept="images/*" (change)="getImages($event)">
                </div>
            </form>
        </div>

        <div class="col-lg-3 col-md-4 col-sm-6 mb-3" *ngFor="let image of window.usher.get().public_configuration?.images; let i = index;">
            <img class="w-100 custom-image-grid" [src]="getPicture(image.name)" alt="">
            <button type="button" class="btn btn-danger btn-block mt-1" (click)="window.usher.get().public_configuration?.images.splice(i, 1)">Elimina</button>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col-12">
            <button type="button" class="btn btn-primary float-right" (click)="update()">Aggiorna</button>
        </div>
    </div>
</div>